export default "https://assets-v2.scaler.com/packs/files/echo-dot.88e1a4.webp";